import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { PrimaryButton } from "../../../../../components/primary/PrimaryButton";
import { useRef } from "react";

const ClusterText = ({ cluster, onGoBack }) => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        const container = containerRef.current.parentElement;
        const scrollWidth = container.scrollWidth - container.clientWidth;
        const scrolled = container.scrollLeft;

        if (scrollWidth > 0) {
          setScrollProgress((scrolled / scrollWidth) * 100);
        } else {
          setScrollProgress(0);
        }
      }
    };

    const container = containerRef.current?.parentElement;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      handleScroll();
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <div className="md:hidden sticky top-[12rem] left-10 z-50 px-4">
        <p className="m-0 p-0 text-white z-60 font-semibold text-xl text-left whitespace-nowrap drop-shadow-[0_2px_2px_rgba(0,0,0,1)]">
          Selección de terreno
        </p>
        <p className="m-0 p-0 text-white font-semibold text-lg text-left whitespace-nowrap drop-shadow-[0_2px_2px_rgba(0,0,0,1)]">
          CLUSTER {cluster}
        </p>
      </div>
      <div className="md:hidden sticky top-[58rem] left-10 px-4">
        <PrimaryButton
          className="flex flex-row items-center text-[#0195B2] mt-20 bg-[#E1EAED] text-[13px] py-1 px-2"
          variant="inner"
          style={{
            borderRadius: "3px",
          }}
          onClick={onGoBack}
        >
          <FaArrowLeft size={20} className="mr-2" />{" "}
          <p className="m-0 p-0">REGRESAR</p>
        </PrimaryButton>
      </div>
      {/* <div className="relative mt-3 mx-auto z-[1000] top-[700px] left-[-20px] w-[820px] ">
        <div className="h-1 w-full bg-[rgba(1,149,178,0.2)]">
          <div
            className="h-full bg-[#0195B2] transition-all duration-300"
            style={{ width: `${scrollProgress}%` }}
          ></div>
        </div>
      </div> */}
    </>
  );
};

export default ClusterText;
